import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "item"]
  static values = { current: { type: String, default: "all" } }

  filter(event) {
    const type = event.currentTarget.dataset.type
    this.currentValue = type
    this.updateButtons()
    this.filterItems()

    const showMore = this.application.getControllerForElementAndIdentifier(this.element, "show-more")
    if (showMore) {
      showMore.recalculate()
    } else {
      this.updateGroups()
    }
  }

  updateButtons() {
    this.buttonTargets.forEach(button => {
      button.classList.toggle("is-active", button.dataset.type === this.currentValue)
    })
  }

  filterItems() {
    this.itemTargets.forEach(item => {
      const itemType = item.dataset.activityType
      const shouldShow = this.currentValue === "all" || itemType === this.currentValue
      item.classList.toggle("hidden", !shouldShow)
    })
  }

  updateGroups() {
    const groups = this.element.querySelectorAll("[data-show-more-target='group']")
    groups.forEach(group => {
      const items = group.querySelectorAll("[data-activity-filter-target='item']")
      const allHidden = Array.from(items).every(item => item.classList.contains("hidden"))
      group.classList.toggle("hidden", allHidden)
    })
  }
}
